<template>
	<div class="app-container">
		<div class="header">
			<el-input size="medium" v-model="search" :placeholder="this.$t('file.adminfile.sesrchhint')" @keyup.enter.native="FileSearch()"
				class="search" />
				<el-button icon="el-icon-search" @click="FileSearch()" type="primary" class="btnInsert">{{$t('file.adminfile.searchbtn')}}</el-button>
				
			<el-button v-if="this.PermissionCheck()" type="success" @click="openInsertFileForm" size="mini" class="btnInsert">{{$t('file.adminfile.insertbtn')}}</el-button>
		</div>


		<el-dialog :title="this.$t('file.adminfile.uploadtitle')" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form :model="otaform">
				<el-form-item :label="this.$t('file.adminfile.uploadbrandcn')" :label-width="formLabelWidth">
					<el-input v-model="otaform.brandC" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('file.adminfile.uploadbranden')" :label-width="formLabelWidth">
					<el-input v-model="otaform.brandE" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('file.adminfile.uploadcarmodel')" :label-width="formLabelWidth">
					<el-input v-model="otaform.carType" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('file.adminfile.uploadcaryear')" :label-width="formLabelWidth">
					<el-input v-model="otaform.carYear" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('file.adminfile.uploadcarconfig')" :label-width="formLabelWidth">
					<el-input v-model="otaform.carConfig" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('file.adminfile.uploadphone')" :label-width="formLabelWidth">
					<el-input v-model="otaform.phone" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('file.adminfile.uploadversion')" :label-width="formLabelWidth">
					<el-input v-model="otaform.version" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
			</el-form>

              <el-upload
                class="upload-demo"
                drag
                :multiple="false"
                :show-file-list="true"
                :auto-upload="false"
                action="string"
                :on-change="handleFileSelect"
                :on-remove="handleFileRemove"
                accept=".bin"
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text" v-html="dragText"></div>
                    <div class="el-upload__tip" slot="tip" v-html="uploadTip"></div>
              </el-upload>

			<div slot="footer" class="dialog-footer">
				<el-button @click="cancle()" style="margin-right: 5px;">{{$t('file.adminfile.uploadcancel')}}</el-button>
                    <el-upload
                      v-if="isUpload()"
                      :multiple="false"
                      :show-file-list="false"
                      :http-request="handleManualUpload"
                      :auto-upload="false"
                      action="string"
                      accept=".bin"
                    >
        					<el-button :disabled="!selectedFile && isUpload()">{{$t('file.adminfile.uploadupload')}}</el-button>
				</el-upload>
				
			</div>
		</el-dialog>


		<el-table :data="otaList" style="width: 100%;">
			<el-table-column label="Id"  prop="" width="100px" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-span type='text'>{{scope.row.otaId}}</el-span>
				</template>
			</el-table-column>
			<el-table-column :label="this.$t('file.adminfile.adminname')" prop="adminName" width="200px"> </el-table-column>
			<el-table-column :label="this.$t('file.adminfile.otaname')" prop="otaName" width="300px"> </el-table-column>
			<el-table-column :label="this.$t('file.adminfile.version')" prop="version" width="200px"> </el-table-column>
			<el-table-column :label="this.$t('file.adminfile.phone')" prop="phone" width="200px"> </el-table-column>
			
			<el-table-column :label="this.$t('file.adminfile.createtime')" prop="createTime" width="200px"> </el-table-column>

			<el-table-column :label="this.$t('file.adminfile.operate')" prop="" fixed="right">
				<template slot-scope="scope">
					<el-tag type="primary" class="btn">
						<el-link  type="success" :href="scope.row.otaUrl">{{$t('file.adminfile.operatedownload')}}</el-link>
					</el-tag>
          <el-tag v-if="PermissionCheck()" type="danger" class="btn">
            <el-link type="danger" @click="deleteOneFile(scope.row.otaId,scope.row.otaUrl)">{{$t('file.adminfile.operatedelete')}}</el-link>
          </el-tag>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
			:page-sizes="[5, 10, 15, 20]" :page-size="length" layout="total, sizes, prev, pager, next, jumper"
			:total="total" class="pagination">
		</el-pagination>
	</div>
</template>

<script>
	export default {
	  computed: {
        dragText() {
          return this.$i18n.locale === 'zh'
            ? '将文件拖到此处，或<em>点击上传</em>'
            : 'Drag the file here, or <em>click to upload</em>';
        },
        uploadTip() {
          return this.$i18n.locale === 'zh'
            ? '只能上传bin文件'
            : 'Only bin files can be uploaded';
        }
      },
		data() {
			return {
				otaList: [{
					otaId: '',
					phone: '',
					createTime: '',
					otaUrl: '',
					otaName: '',
					version: ''
				}],
				otaform: {
					otaUrl: '',
					phone: '',
					version: '',
					brandC:'',
					brandE:'',
					carType: '',
					carYear: '',
					carConfig: ''
				},
				search: "",
				length: 5,
				page: 1,
				total: 0,
				dialogWidth: "30%",
				dialogTitle: '上传OTA文件',
				dialogFormVisible: false,
				formLabelWidth: '120px',
				btnName: '上传',
				selectedFile: null,
			};
		},
		created() {
			this.reload();
		},
		methods: {
		    handleFileSelect(file, fileList) {
                this.selectedFile = file.raw; // file.raw 是原生的 File 对象
            },

            handleFileRemove(file, fileList) {
                this.selectedFile = null;
            },
			isUpload(){
				/**
				 * otaUrl: '',
					phone: '',
					version: '',
					brand:'',
					carType: '',
					carYear: '',
					carConfig: ''
				 */
				if(this.otaform.phone == '' || this.otaform.version == '' || this.otaform.brandC == '' ||this.otaform.brandE == '' || this.otaform.carType == '' || this.otaform.carYear == '' || this.otaform.carConfig == ''){
					return false;
				}
				return true;
			},
			change(e) {
				this.$forceUpdate();
			},
			cancle() {
				this.dialogFormVisible = false;
				this.reload();
			},
			reload() {
				let that = this;
				let length = that.length;
				let page = that.page;
				that.getRequest('/tpa-api/manageFile/getAllAdminFiles?length=' + length + '&page=' + page, null).then(
					resp => {
						if (resp) {
							that.otaList = resp.result;
							that.total = resp.total;
						}
					});
			},
			// 分页功能
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.length = val;
				this.reload();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.reload();
			},
			FileSearch() {
				let that = this;
				let adminName = that.search;
				let length = that.length;
				let page = that.page;
				that.getRequest('/tpa-api/manageFile/getAllAdminFiles?length=' + length + '&page=' + page + '&adminName=' +
					adminName, null).then(
					resp => {
						if (resp) {
							that.otaList = resp.result;
							that.total = resp.total;
						}
					});
			},
			deleteOneFile(otaId, otaUrl) {
				console.log(otaUrl)
				// 跳出确认框
				let that = this;
				that.$confirm(this.$t('notification.adminfilemessage'), this.$t('notification.title'), {
					confirmButtonText: this.$t('notification.confirm'),
					cancelButtonText: this.$t('notification.cancel'),
					type: 'warning'
				}).then(() => {
					// 发送ajax请求删除数据
					that.deleteRequest('/tpa-api/manageFile/deleteOneOtaFile?otaId=' + otaId + '&otaUrl=' + otaUrl,
						null).then(resp => {
						if (resp.code == 200) {
							that.page=1;
							that.length = 5;
							that.reload();
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: this.$t('notification.cancelinfo')
					});
				});
			},
			openInsertFileForm() {
				this.otaform={
					otaUrl: '',
					phone: '',
					version: '',
					brandC:'',
					brandE:'',
					carType: '',
					carYear: '',
					carConfig: ''
				};
				
				this.dialogFormVisible = true;
			},
			uploadFile(param) {
			    if (!this.selectedFile) {
                  this.$message.warning('请先选择一个APK文件');
                  return;
                }
				let that = this;
				let formData = new FormData();
				formData.append('file', that.selectedFile);
				formData.append('phone',that.otaform.phone);
				formData.append('version',that.otaform.version);
				formData.append('brandC',that.otaform.brandC);
				formData.append('brandE',that.otaform.brandE);
				formData.append('carType',that.otaform.carType);
				formData.append('carYear',that.otaform.carYear);
				formData.append('carConfig',that.otaform.carConfig);
				that.postFormRequest('/tpa-api/manageFile/uploadOta', formData).then(resp => {
					if (resp.code == 200) {
						that.reload();
						that.otaform={
							otaUrl: '',
							phone: '',
							version: '',
							brandC:'',
							brandE:'',
							carType: '',
							carYear: '',
							carConfig: ''
						};
						that.dialogFormVisible = false;
						that.selectedFile = null;
						that.$refs.uploadRef.clearFiles();
					}
					
				})
				.catch((err) => {
                            console.error(err);
                            this.$message.error('上传失败');
                          });
			},
      PermissionCheck(){
        var userInfo = JSON.parse(window.localStorage.getItem("user"));
        var permission = userInfo.permission;
        if (permission.length === 5){
          return false;
        }
        else if (permission.length === 8){
          return true;
        }
        return false;
      }
		}
	};
</script>
<style scoped>
	.avatar {
		height: 50px;
	}

	.pagination {
		display: flex;
		float: left;
		margin-left: 10px;
		margin-top: 40px;
	}

	.btnInsert {
		margin-left: 50px;
		height: 36px;
		font-size: 10px;
		line-height: 10px;
		float: right;
	}

	.search {
		width: 30%;
		height: 50px;

	}

	.header {
		display: flex;
		flex-direction: row;
	}

	.btn {
		cursor: pointer;
	}

	.a1 {
		text-decoration: none;
	}
	
	.dialog-footer{
		display: flex;
		float: right;
		margin-top: -30px;
	}
</style>
